import { actionTypes } from '../actions/subsidiaries'

const initial = {
	directors: [],
  brokers: [],
	operation_types: [],
  subsidiaries : [],
  news: [],
  imis: [],
  nordelta: [],
  centro: [],
  puertos: [],
  sanisidro: [],
  palermo: [],
  pilar: [],
  escobar: [],
  list: []
}

export default (state = initial, action) => {
  switch (action.type) {
    case actionTypes.RECEIVE_DIRECTORS:
      return Object.assign({}, state, {
        directors: action.data
    })

    case actionTypes.RECEIVE_BROKERS:
      return Object.assign({}, state, {
        brokers: action.data
    })

    case actionTypes.RECEIVE_OPERATION_TYPES:
      return Object.assign({}, state, {
        operation_types: action.operations
      })

    case actionTypes.RECEIVE_NEWS:
      return Object.assign({}, state, {
        news: action.data
    })

    case actionTypes.RECEIVE_IMIS:
      return Object.assign({}, state, {
        imis: action.data
    })

    case actionTypes.RECEIVE_NORDELTA:
      return Object.assign({}, state, {
        nordelta: action.data
    })

    case actionTypes.RECEIVE_CENTRO:
      return Object.assign({}, state, {
        centro: action.data
    })

    case actionTypes.RECEIVE_SANISIDRO:
      return Object.assign({}, state, {
        sanisidro: action.data
    })

    case actionTypes.RECEIVE_PUERTOS:
      return Object.assign({}, state, {
        puertos: action.data
    })

    case actionTypes.RECEIVE_PILAR:
      return Object.assign({}, state, {
        pilar: action.data
    })

    case actionTypes.RECEIVE_ESCOBAR:
      return Object.assign({}, state, {
        escobar: action.data
    })

    case actionTypes.RECEIVE_PALERMO:
      return Object.assign({}, state, {
        palermo: action.data
    })

    case actionTypes.RECEIVE_SUBSIDIARY_TYPES:
      let subsidiaries = []
      for (var i in action.data){
        subsidiaries.push({name: action.data[i].name, id: action.data[i].id})
      }
      return Object.assign({}, state, { subsidiaries })

    case actionTypes.RECEIVE_SUBSIDIARIES_LIST:
      return Object.assign({}, state, {
        list: action.data
    })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/subsidiaries.js